import _createClass from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var ParticlesInteractorBase = /*#__PURE__*/_createClass(function ParticlesInteractorBase(container) {
  _classCallCheck(this, ParticlesInteractorBase);

  this.container = container;
  this.type = 1;
});